S.headerSearchlayer =
    {
        elements: {
            $clear: null,
            $close: null,
        },

        init() {
            this.initSearchLayer();
            this.closeSearchLayer();
        },

        initSearchLayer() {
            this.elements.$clear.on('click', (e) => {
                $(e.currentTarget).prev('input').val('');
            });
        },

        closeSearchLayer() {
            this.elements.$close.on('click', () => {
// e.stopPropagation().preventDefault();

                if ($('#header').length > 0) {
// bei mobile offen
                    if ($('#header').hasClass('is-mobile-nav-open')) {
                        S.header.closeMobileNav();
                    }

                    S.header.searchLayerClose();
                }
            });
        },
    };